import React, { useContext } from "react";
import styled from "styled-components";
import { UserSettingsContext } from "../context/userSettings";
// stylesTheme import removed - not currently needed
import { borderRadius, getColor } from "../styles/stylesUtils";

const TranslateToggle = () => {
    const { translateMode, setTranslateMode } = useContext(UserSettingsContext);

    return (
        <ToggleStyles>
            <div
                className="toggle-slider"
                data-active={translateMode ? "on" : "off"}
            ></div>
            <button
                className={`toggle-option off ${
                    !translateMode ? "active" : ""
                }`}
                onClick={() => setTranslateMode(false)}
            >
                Tap to translate
            </button>
            <button
                className={`toggle-option on ${translateMode ? "active" : ""}`}
                onClick={() => setTranslateMode(true)}
            >
                Auto-translate
            </button>
        </ToggleStyles>
    );
};

const ToggleStyles = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(max-content, 1fr));
    width: max-content;
    max-width: calc(100vw - 2em);
    position: relative;
    background: ${getColor("black", 0.08)};
    overflow: hidden;
    ${borderRadius(0.5)};
    text-align: center;
    backdrop-filter: blur(1em);
    -webkit-backdrop-filter: blur(1em);
    font-size: 1.2em;

    .toggle-slider {
        position: absolute;
        top: 0.2em;
        bottom: 0;
        left: 0.2em;
        background: ${getColor("colorYou")};
        ${borderRadius(0.38)};
        width: calc(50% - 0.2em);
        height: calc(100% - 0.4em);
        transition: left 0.2s ease-out;
        box-shadow: 0 0.05em 0.1em 0 rgba(0, 0, 0, 0.1);
    }

    .toggle-slider[data-active="off"] {
        left: 0.2em;
    }

    .toggle-slider[data-active="on"] {
        left: 50%;
    }

    .toggle-option {
        position: relative;
        background: transparent;
        border: none;
        outline: none;
        cursor: pointer;
        z-index: 1;
        height: 3em;
        box-shadow: none;
        font-size: 0.85em;
        font-weight: 500;
        color: ${getColor("black", 0.5)};
        padding: 0 1.6em;
        white-space: nowrap;
        transition: color 0.2s;

        &:hover {
            color: ${getColor("black", 0.7)};
        }

        &.active {
            color: ${getColor("colortextYou")};

            &:hover {
                color: ${getColor("colortextYou")};
            }
        }
    }

    .toggle-option.off {
        grid-column: 1;
    }

    .toggle-option.on {
        grid-column: 2;
    }
`;

export default TranslateToggle;
